import { IMSAggregator } from './aggregator';
import { isNil } from 'lodash';

export class CountAggregator extends IMSAggregator {
    constructor() {
        super();
        this.logicalName = 'count';
        this.displayName = 'Count';
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     * Returns the mode of the value array.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray) {
        return isNil(valueArray) ? 0 : valueArray.length;
    }
}
